import { Table } from 'reactstrap';

// Static Assets
import Title1Line from '../../../assets/images/frames/title1line@2x.png';
import Rank from '../../../assets/images/icons/rank.png';
import PaperPrice from '../../../assets/images/icons/paper_price.png';
import Wallet from '../../../assets/images/icons/wallet.png';
import PaperGold from '../../../assets/images/icons/paper_gold_outline@2x.png';
import { IAuctionBiderObj } from 'api/types/marketplace';
import AppConfig from 'config/config';

interface Props {
  quantity: number;
  auctionList: Array<IAuctionBiderObj>;
}

const AuctionLeaderboard = ({ auctionList, quantity }: Props) => {
  return (
    <>
      <div className="aution-leaderboard">
        <div className="aution-leaderboard-wrap">
          <div className="title-wrap">
            <img src={Title1Line} alt="Title2Line" className="img-fluid" />
            <h2 className="title-text">AUCTION LEADERBOARD</h2>
          </div>
          <div className="aution-leaderboard-content">
            <div className="aution-leaderboard-table">
              <Table responsive>
                <thead>
                  <tr>
                    <th>
                      <div className="d-flex align-items-center">
                        <span className="icon-10">
                          <img src={Rank} alt="Rank" className="img-fluid" />
                        </span>
                        RANK
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <span className="icon-10">
                          <img src={PaperPrice} alt="Price" className="img-fluid" />
                        </span>
                        PRICE
                      </div>
                    </th>
                    <th>
                      <div className="d-flex align-items-center">
                        <span className="icon-10">
                          <img src={Wallet} alt="Wallet" className="img-fluid" />
                        </span>
                        FROM
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {auctionList.length > 0 ? (
                    auctionList.map((obj, key) => (
                      <tr key={key}>
                        <td className={`${key >= quantity ? `disabled` : ``}`}>#{key + 1}</td>
                        <td className={`${key >= quantity ? `disabled` : ``}`}>
                          <div className="d-flex align-items-center">
                            <span className="icon-10">
                              <img src={PaperGold} alt="Paper Gold" className="img-fluid" />
                            </span>
                            {obj.bidAmount}
                          </div>
                        </td>
                        <td>
                          <a
                            href={`${AppConfig.EXPLORER_URL}/address/${obj.bidderAddress}`}
                            target="_blank"
                            rel="noreferrer"
                            className="link-leaderboard"
                          >
                            {obj.bidderAddress.substring(0, 4)}...{obj.bidderAddress.slice(-4)}
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">
                        No bidders found...
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuctionLeaderboard;
